import {
  GET_LAYOUT_MAP,
  SET_LAYOUT_MAP,
} from "../constants/layout-map-constants";

export const getLayoutMap = () => ({
  type: GET_LAYOUT_MAP,
});

export const setLayoutMap = (data) => ({
  type: SET_LAYOUT_MAP,
  data,
});
